import PropTypes from 'prop-types';
import React from 'react';
import Typography from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Typography';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';

const styles = theme => ({
  title: {
    fontWeight: theme.typography.fontWeightExtraBold,
    color: theme.palette.facet.primaryBlue,
    marginTop: theme.spacing(0.5),
    marginBottom: theme.spacing(0.5),
    marginRight: theme.spacing(1),
  },
  titleText: {
    color: theme.palette.facet.primaryBlue,
    fontWeight: theme.typography.fontWeightMedium,
    marginTop: theme.spacing(0.5),
    marginBottom: theme.spacing(0.5),
  },
  timeTextContainer: {
    display: 'flex',
    alignItems: 'center',
  },
});

const NewMeetingLocation = ({ classes, value }) => {
  return (
    <div className={classes.timeTextContainer}>
      <Typography variant="h3" className={classes.title}>
        Zoom:
      </Typography>
      <Typography variant="h3" className={classes.titleText}>
        {value}
      </Typography>
    </div>
  );
};

NewMeetingLocation.propTypes = {
  classes: PropTypes.object.isRequired,
  value: PropTypes.string.isRequired,
};
NewMeetingLocation.defaultProps = {};

export default withStyles(styles)(NewMeetingLocation);
